import type { FlowPolicy } from "~/components/participation/state";
import type { CheckoutDraft } from "./checkout-state";

export type CheckoutFacts = {
  approval: boolean;
  group: boolean;
  selectionAvailable: boolean;
  guestsComplete: boolean;
  detailsComplete: boolean;
  phoneComplete: boolean;
  profileComplete: boolean;
  questionsRequired: boolean;
  questionsComplete: boolean;
  emailRequired: boolean;
  acceptedWaitlist: boolean;
  showingStatus: boolean;
};

export function checkoutParticipationPolicy(facts: CheckoutFacts, draft: Pick<CheckoutDraft, "attempt" | "walletIntentID" | "editingPayment" | "paymentPhase">): FlowPolicy {
  const frozen = !draft.editingPayment && !!draft.attempt;
  const recovery = frozen && (!draft.walletIntentID || draft.paymentPhase === "processing");
  const details = facts.approval
    ? [
        { id: "phone" as const, complete: facts.phoneComplete, skip: facts.phoneComplete, skipBack: facts.phoneComplete },
        { id: "profile" as const, complete: facts.profileComplete, skip: facts.profileComplete },
      ]
    : [{ id: "details" as const, complete: facts.detailsComplete, skip: facts.detailsComplete, skipBack: facts.detailsComplete }];
  return {
    allowStatus: true,
    terminal: facts.showingStatus ? "status" : undefined,
    recovery: recovery ? (!facts.phoneComplete ? facts.approval ? "phone" : "details" : facts.approval && !facts.profileComplete ? "profile" : "payment") : undefined,
    steps: [
      { id: "tickets", complete: frozen || facts.selectionAvailable },
      ...(facts.group ? [{ id: "guests" as const, complete: frozen || facts.guestsComplete }] : []),
      ...(!facts.acceptedWaitlist ? details : []),
      ...(!facts.acceptedWaitlist && (facts.approval || facts.questionsRequired) ? [{ id: "questions" as const, complete: frozen || facts.questionsComplete }] : []),
      ...(facts.emailRequired ? [{ id: "email" as const, complete: false }] : []),
      { id: "payment", complete: false },
    ],
  };
}
